<div
	*ngIf="controller.isLoading$ | async; else streeme"
	class="
		top-0
		left-0
		right-0
		bottom-0
		flex
		absolute
		items-center
		flex-col
		justify-center
		bg-white
	"
	style="z-index: 100"
>
	<div *ngIf="controller.isRedirecting$ | async">
		{{ 'presentation.app.redirecting' | translate }}
	</div>
	<p-progressSpinner></p-progressSpinner>
</div>
<ng-template #streeme>
	<spr-app-toolbar
		*ngIf="controller.showAppToolbar$ | async"
		[isFocusModeVisible]="controller.showFocusMode$ | async"
		[style.height.px]="controller.appToolbarHeight$ | async"
	></spr-app-toolbar>
	<div
		[style.padding-top.px]="controller.appPaddingTopPx$ | async"
		class="h-full flex flex-row items-stretch"
	>
		<spr-app-sidebar
			*ngIf="controller.isConnected$ | async"
			[@sideBarStatus]="controller.sideBarStatus$ | async"
			[showToggleButton]="controller.showSidebarToggleButton$ | async"
			[style.top.px]="controller.appPaddingTopPx$ | async"
			[style.width.px]="controller.appSlideWidthPx$ | async"
		></spr-app-sidebar>
		<div
			[style.margin-left.px]="controller.contentMarginLeftPx$ | async"
			class="flex flex-auto items-stretch flex-col bg-grey-alabaster"
			style="transition: margin 150ms linear"
		>
			<div class="h-full overflow-hidden">
				<router-outlet></router-outlet>
			</div>
		</div>
		<spr-app-chat
			*ngIf="controller.showChat$ | async"
			[@chatStatus]="controller.chatStatus$ | async"
			[showToggleButton]="controller.showChatToggleButton$ | async"
			[style.top.px]="controller.appPaddingTopPx$ | async"
			[style.width.px]="controller.appChatWidthPx$ | async"
			[user]="controller.appChatUser$ | async"
		></spr-app-chat>
	</div>
</ng-template>
<p-confirmDialog
	[header]="'presentation.app.confirmationDialog.header' | translate"
	icon="pi pi-exclamation-triangle"
></p-confirmDialog>
<button
	*ngIf="controller.showDisableFocusMode$ | async"
	(click)="onFocusModeClick()"
	class="fixed top-4 right-4 p-rounded p-shadow z-20"
	icon="fas fa-compress"
	pButton
></button>
<p-toast position="bottom-center"></p-toast>
